// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sidebar-color: #190032;
  --screen-color: #eceaea;

  --grid-even-color: #eceaea;
  --grid-odd-color: rgba(246, 239, 239, 0.748);
  --even-row-hover:#e2e0e0;
  --main-font: 'Poppins', sans-serif;

  --selecte-row-color:#ff6e61a9;

   --black : black;
   --orange:#ff6e61a9;

   --grid-header-color : #eceaea;
}

html, body, #root {
 width: 100vw;
 height:100vh;
 font-family: var(--main-font);
 background-color: var(--screen-color);
 display:relative;
}

*{
    padding: 0;
    margin: 0;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,wBAAwB;EACxB,uBAAuB;;EAEvB,0BAA0B;EAC1B,4CAA4C;EAC5C,wBAAwB;EACxB,kCAAkC;;EAElC,6BAA6B;;GAE5B,eAAe;GACf,kBAAkB;;GAElB,6BAA6B;AAChC;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,6BAA6B;CAC7B,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;IACI,UAAU;IACV,SAAS;AACb","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');\n\n:root {\n  --sidebar-color: #190032;\n  --screen-color: #eceaea;\n\n  --grid-even-color: #eceaea;\n  --grid-odd-color: rgba(246, 239, 239, 0.748);\n  --even-row-hover:#e2e0e0;\n  --main-font: 'Poppins', sans-serif;\n\n  --selecte-row-color:#ff6e61a9;\n\n   --black : black;\n   --orange:#ff6e61a9;\n\n   --grid-header-color : #eceaea;\n}\n\nhtml, body, #root {\n width: 100vw;\n height:100vh;\n font-family: var(--main-font);\n background-color: var(--screen-color);\n display:relative;\n}\n\n*{\n    padding: 0;\n    margin: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
